import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { QuicklinkSharedModule } from '@core/ngx-quicklink.shared.module';
import { LayoutComponent } from '@features/profile-unlogged/layout/layout.component';
import { ProfileUnloggedGuard } from '@routing/profile-unlogged/profile-unlogged.guard';
import { ProfileRoutingEnum } from '@routing/profile/profile-routing.enum';

const routes: Routes = [
  {
    path: ProfileRoutingEnum.View,
    component: LayoutComponent,
    canActivate: [ProfileUnloggedGuard],
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes), QuicklinkSharedModule],
  exports: [RouterModule],
})
export class ProfileUnloggedRoutingModule {}
